import React from 'react';
type LogoProps = {
  className?: string;
};
export function Logo({
  className = ''
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/1AX3ct8kqZsNfV9ftQvMkX/brandmark-(light).svg" alt="Magic Patterns" className={className} draggable={false} data-id="element-11" />;
}